import React from "react";
import { Container, Row } from "react-bootstrap";

const Footer = () => {
    return (
        <>
            <div className="footer">
                <Container>
                    <Row>
                        <p>Copyright © 2022-2024 GateZero - All Rights Reserved.</p>
                    </Row>
                </Container>
            </div>
        </>
    );
}
 
export default Footer;